/** Find keys that have different values between two objects */
export const diffKeys = (a: { [x: string]: unknown }, b: { [x: string]: unknown }): string[] => {
  const diff: string[] = []

  const aKeys = Object.keys(a)
  for (const aKey of aKeys) {
    if (a[aKey] !== b[aKey]) {
      diff.push(aKey)
    }
  }

  const bKeys = Object.keys(b)
  for (const bKey of bKeys) {
    if (b[bKey] !== a[bKey] && !aKeys.includes(bKey)) {
      diff.push(bKey)
    }
  }
  return diff
}

/** Return a new object with the provided key removed (original object is not mutated) */
export const omitKey = <T extends { [key: string]: unknown }>(
  obj: { [key: string]: unknown },
  key: string
) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-unused-vars
  const { [key]: omit, ...res } = obj
  return res as T
}

/** Check if the provided object is empty */
export const objectIsEmpty = (obj: unknown) => {
  try {
    if (obj === null || obj === undefined) return true
    return (
      typeof obj === 'object' &&
      obj.constructor === Object &&
      (Object.keys(obj).length === 0 ||
        Object.values(obj).every((x) => x === null || x === undefined))
    )
  } catch {
    return false
  }
}
